var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "XRP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.218898%",
    y1: "9.17426215%",
    x2: "87.2913707%",
    y2: "91.1295573%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAE4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006097",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ripple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XRP"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1-Copy-2",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7335891,11.0085285 C28.320103,12.3518234 26.833369,14.8338995 26.833369,17.5203203 C26.833369,18.976952 27.3708886,20.3175404 28.0568711,21.5610313 C28.6337,22.6067748 28.9255365,24.5475408 26.9472607,25.6485995 C25.4754431,26.4676694 23.638786,25.9488575 22.7213349,24.5336698 C21.9465555,23.3383893 21.0110292,22.2183848 19.7013625,21.4893077 C15.9706638,19.413045 11.2001989,20.6452022 9.04625954,24.2413623 C8.33676168,25.4259857 7.9996493,26.7195478 8.00000027,27.9956864 C8.00368552,30.5987116 9.40214914,33.1212168 11.9012733,34.5120456 C14.3145838,35.8551713 17.2878765,35.8551713 19.7013625,34.5120456 C21.0106782,33.7833068 21.9462046,32.6641481 22.720633,31.4693751 C23.3566014,30.4884196 24.9447675,29.237824 26.9470852,30.3530921 C28.4164459,31.1714854 28.8707843,32.964406 28.0561691,34.4413369 C27.3705377,35.6846587 26.8335445,37.0249087 26.8335445,38.4813713 C26.8335445,42.6337276 30.325755,46 34.6336337,46 C38.9413368,46 42.4333719,42.6337276 42.4333719,38.4813713 C42.4333719,35.7952889 40.9468133,33.3130436 38.5335028,31.970087 C37.2131313,31.2350893 35.7260463,31.0221176 34.2533512,30.9725539 C33.017565,30.9309407 31.1738884,30.1675242 31.1738884,28.0007612 C31.1738884,26.3863037 32.5316388,25.0869902 34.2538777,25.0289686 C35.7267482,24.9792357 37.2134823,24.7660948 38.5335028,24.0314355 C41.0328024,22.6406067 42.4314415,20.1177631 42.4347758,17.5225193 C42.4365307,16.2438433 42.0994183,14.9475747 41.3885165,13.760583 C39.9488132,11.3568277 37.3393072,10.0093038 34.6532883,10 C33.2843067,10.0045673 31.9534059,10.3296917 30.7335891,11.0085285 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img-3.5050e3cf098761f978f837fe23a89389.svg";
export { ForwardRef as ReactComponent };